import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ReportRunEmailModel extends ModeModelBase {
  override _name = 'reportRunEmail';
  override belongsTo = 'reportRun';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'recipient_address', default: '' },
    { name: 'message', default: '' },
    { name: 'csv_attachments_enabled', default: true },
    { name: 'pdf_attachments_enabled', default: false },
    { name: 'data_previews_enabled', default: false },
    { name: 'data_tables_enabled', default: false },
    { name: 'report_links_enabled', default: false },
  ];
}

@Injectable({ providedIn: 'root' })
export class ReportRunEmailModelAccessor extends ModelAccessorBase<ReportRunEmailModel> {
  override name = 'reportRunEmail';
  override parentModel = 'reportRun';
  override parentIdAttribute = 'token';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.reportRunEmail');
  }

  createModel(resource, opts?) {
    const model = new ReportRunEmailModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
